checkOrderStatus = ->

    $.ajax(
        url: '/ajax/check_order_status.script'
        type: 'POST'
        dataType: 'JSON'
        data:  
            ahoj: 'zdar'
            
    ).done((data) ->
        
        console.log data

        if $('#order_status').length

            $('#order_status').find('tr.new td.right').text(data.orders.new ? '0');
            $('#order_status').find('tr.ready td.right').text(data.orders.ready ? '0');
            $('#order_status').find('tr.picked td.right').text(data.orders.picked ? '0');
            $('#order_status').find('tr.done td.right').text(data.orders.done ? '0');
            $('#order_status').find('tr.dead td.right').text(data.orders.dead ? '0');


        return
    ).fail (jqXHR) ->
        console.error jqXHR.responseText
        return

    return false